import { Tooltip, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { ChevronDown, Info } from 'lucide-react';
import React from 'react';
import { FeedOption } from 'views/bluviu-nutrition/types/feed-option.type';

interface Props {
  value: FeedOption;
}

const Option = React.memo(function Treatment(props: Props) {
  const { value } = props;
  const theme = useTheme();

  return (
    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} height={'100%'}>
      <Box
        textOverflow={'ellipsis'}
        overflow={'hidden'}
        title={value.label}
        display={'flex'}
        flexDirection={'row'}
        gap={4}
        alignItems={'center'}
        justifyContent={'center'}>
        <Typography noWrap={true}>{value.label || ''}</Typography>
        {!!value.id && !value.isActive && (
          <Tooltip
            title={
              'This feed was set to inactive since last saved. It can still be used, but will not be selectable if changed and saved.'
            }
            onClick={(e) => e.stopPropagation()}>
            <Info size={18} />
          </Tooltip>
        )}
      </Box>
      <ChevronDown size={18} color={theme.palette.darkBlue.main} />
    </Box>
  );
});

export function renderFeedOption(params: GridRenderCellParams<FeedOption, any, any>) {
  if (params.value == null) {
    return '';
  }

  return <Option value={params.value} />;
}
